<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      :title="type == 1 ? '增加库存' : '减少库存'"
      :modal-append-to-body="false"
      width="30%"
      style="margin-top: 180px"
    >
      <div class="container_dialog">
        <div class="container_item">
          <div class="label">所属地点:</div>
          <div class="value">{{ row.place }}</div>
        </div>
        <div class="container_item" v-if="type == 2">
          <el-radio v-model="radio" label="3">丢失</el-radio>
          <el-radio v-model="radio" label="2">损坏</el-radio>
          <el-radio v-model="radio" label="1">其他</el-radio>
        </div>
        <div class="container_item">
          <div class="label">{{type == 1 ? '增加库存' : '减少库存'}}:</div>
          <div class="value">
            <el-input-number v-model="num" :min="1"></el-input-number>
          </div>
        </div>
        <div class="container_item">
          <div class="label">调整原因:</div>
          <div class="value">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="reason"
            >
            </el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <template>
          <el-button @click="finished" class="no">取消</el-button>
          <el-button @click="submit" class="ok"> 提交 </el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import moment from "moment";
import { getToken } from "@/utils/cookie";
import apis from "@/apis/borrowingAnUmbrella";
export default {
  name: "dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "1",
    },
    row: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      radio: "1",
      num: 1,
      reason: "",
    };
  },
  watch: {
    visible(v) {
      this.dialogVisible = v;
    },
  },
  mounted() {},
  methods: {
    // 关闭弹窗
    beforeClose(done) {
      this.step = 1;
      this.fileList = [];
      this.$emit("update:visible", false);
      done();
    },
    //刷新数据
    finished() {
      this.step = 1;
      this.fileList = [];
      this.$emit("update:visible", false);
      this.$emit("changeUpload");
    },
    // 提交数据
    submit() {
      const params = {
        buId: this.row.id,
        num: this.num,
        empNo: getToken(),
        reason: this.reason,
      };
      // 根据 type 的值设置接口调用和提示信息
      const apiCall = this.type == 1 ? apis.addStock : apis.reduceStock;
      const message = this.type == 1 ? "增加库存成功" : "减少库存成功";
      // 如果是减少库存，需要额外设置 type 参数
      if (this.type != 1) {
        params.type = this.radio;
      }
      apiCall(params).then((res) => {
        console.log(res, "res");
        this.$emit("changeSubmit");
        this.$emit("update:visible", false);
        this.$message({
          type: "success",
          message,
          duration: 2000,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.container_dialog {
  padding-left: 50px;
  .container_item {
    display: flex;
    align-items: flex-start;
    font-size: 11px * $zoom;
    margin-bottom: 50px;
    color: #282b32;
    .value {
      margin-left: 20px;
      flex: 1;
      ::v-deep {
        .el-textarea__inner {
          background: #fafafa;
          border-radius: 20px;
          border: none;
        }
      }
    }
    ::v-deep {
      .is-checked {
        .el-radio__label {
          color: #606266;
        }
      }
      .el-radio__input.is-checked .el-radio__inner {
        background: #4fa27d;
        border-color: #4fa27d;
      }
    }
  }
  .container_item:nth-child(1) {
    .value {
      color: #666666;
    }
  }
}
.dialog-footer {
  .ok {
    width: 75px * $zoom;
    height: 32px * $zoom;
    background: #4fa27d;
    border-radius: 20px;
    font-size: 11px * $zoom;
    color: #fff;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .no {
    width: 75px * $zoom;
    height: 32px * $zoom;
    background: none;
    border-radius: 20px;
    font-size: 11px * $zoom;
    color: #666;
    border: 1px solid #666;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
::v-deep {
  .el-dialog {
    margin-top: 0 !important;
    border-radius: 30px;
  }
  .el-dialog__header {
    padding: 0 !important;
    height: 150px;
    border-bottom: 1px solid #ccc;
    position: relative;
    .el-dialog__title {
      position: absolute;
      top: 35%;
      left: 50px;
    }
    .el-dialog__headerbtn {
      top: 35%;
      font-size: 40px;
    }
  }
  .el-dialog__body {
    // background: #f7f9fa;
    // height: 75vh;
    // overflow: auto;
    // &::-webkit-scrollbar {
    // display: none;
    // }
  }
}
</style>
